module.exports = __webpack_public_path__ + "img/category_example_bible.38c911d9.jpg";